// export const getSessionId = () => {
//   let id = localStorage.getItem("leadbook_session_id");

//   if (!id) {
//     id = crypto.randomUUID();
//     localStorage.setItem("leadbook_session_id", id);
//   }

//   return id;
// };
import { v4 as uuidv4 } from "uuid";

export const getSessionId = () => {
  if (typeof window === "undefined") return uuidv4();

  let id = sessionStorage.getItem("sessionId");
  if (!id) {
    id = uuidv4();
    sessionStorage.setItem("sessionId", id);
  }
  return id;
};
